export const commonEnv = {
  production: false,
  environmentName: 'local',
  serverUrl: 'http://localhost:48200',
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'fr-FR'],
};
